// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 15px 15px 0px 15px;
    background-color: #ffffff;
    color: #44556F;
  }
  
  .logo {
    width: 50px;
    height: 50px;
    margin-right: 15px;
  }
  
  .menu-options {
    display: flex;
    min-width: 80vw;
    display: flex;
    justify-content: flex-start;
  }
  
  .menu-options a {
    padding: 0px 2.5vw;
    color: #44556F;
    text-decoration: none;
    display: flex;
    align-items: center;
  }

  .menu-options a:hover{
    border-bottom: 2px solid #3b82f5;
    color: #3b82f5
  }

  .menu-options img{
    max-width: 20%;
    margin-bottom: 0.5em;
  }
  
  .user-greeting {
    min-width: 15vw;
    display: flex;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .user-greeting p {
    margin-bottom: 0rem !important;
  }
  
  .user-greeting button {
    background-color: transparent;
    color: #3b82f5;
    border: none;
    cursor: pointer;
    font-size: 12px;
    width: 50%;
  }

  .user-greeting button:hover{
    border-bottom: 2px solid #3b82f5;
  }

  .menu-button{
    display: none;
  }
  
  @media (max-width: 600px) {
    .menu-container{
        flex-direction: column;
        align-items: left;
    }

    .logo_senai{
        display: none;
    }

    .menu-options {
        display: none;
        flex-direction: column;
        align-items: flex-start;
    }

    .menu-options svg{
        display: none;
    }

    .menu-button {
        display: block;
        border: none;
        background-color: transparent;
    }

    .menu-open .menu-options {
        display: flex;
    }

    .user-greeting{
      width: 100%;
    }

    .user-greeting p {
        display: none;
      }

    .opened{
        display: block;
        
    }

    .closed{
        display: none;
    }

    .user-greeting button {
      width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Menu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC;EACF;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,6BAA6B;IACjC;;IAEA;QACI,aAAa;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;QACI,aAAa;MACf;;IAEF;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;IACjB;;IAEA;MACE,WAAW;IACb;AACJ","sourcesContent":[".menu-container {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    padding: 15px 15px 0px 15px;\n    background-color: #ffffff;\n    color: #44556F;\n  }\n  \n  .logo {\n    width: 50px;\n    height: 50px;\n    margin-right: 15px;\n  }\n  \n  .menu-options {\n    display: flex;\n    min-width: 80vw;\n    display: flex;\n    justify-content: flex-start;\n  }\n  \n  .menu-options a {\n    padding: 0px 2.5vw;\n    color: #44556F;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n  }\n\n  .menu-options a:hover{\n    border-bottom: 2px solid #3b82f5;\n    color: #3b82f5\n  }\n\n  .menu-options img{\n    max-width: 20%;\n    margin-bottom: 0.5em;\n  }\n  \n  .user-greeting {\n    min-width: 15vw;\n    display: flex;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  \n  .user-greeting p {\n    margin-bottom: 0rem !important;\n  }\n  \n  .user-greeting button {\n    background-color: transparent;\n    color: #3b82f5;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    width: 50%;\n  }\n\n  .user-greeting button:hover{\n    border-bottom: 2px solid #3b82f5;\n  }\n\n  .menu-button{\n    display: none;\n  }\n  \n  @media (max-width: 600px) {\n    .menu-container{\n        flex-direction: column;\n        align-items: left;\n    }\n\n    .logo_senai{\n        display: none;\n    }\n\n    .menu-options {\n        display: none;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .menu-options svg{\n        display: none;\n    }\n\n    .menu-button {\n        display: block;\n        border: none;\n        background-color: transparent;\n    }\n\n    .menu-open .menu-options {\n        display: flex;\n    }\n\n    .user-greeting{\n      width: 100%;\n    }\n\n    .user-greeting p {\n        display: none;\n      }\n\n    .opened{\n        display: block;\n        \n    }\n\n    .closed{\n        display: none;\n    }\n\n    .user-greeting button {\n      width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
